
import { supabase } from "@/integrations/supabase/client";
import { Employee, EmployeeFormData } from "@/components/admin/employees/types";

interface ProfileResult {
  success: boolean;
  error: any | null;
}

export const useEmployeeProfile = () => {
  const createProfile = async (userId: string, formData: EmployeeFormData): Promise<ProfileResult> => {
    try {
      console.log("Creating profile for user:", userId);
      console.log("Profile data to save:", formData);
      console.log("Phone number to save:", formData.phone);
      
      // Create the profile data object with explicit phone field
      const profileData = {
        id: userId,
        first_name: formData.first_name || '',
        last_name: formData.last_name || '',
        email: formData.email,
        phone: formData.phone || '', // Ensure phone is never null
        street: formData.street || '',
        city: formData.city || '',
        state: formData.state || '',
        zip_code: formData.zip_code || ''
      };
      
      console.log("Final profile data being saved:", profileData);
      
      const { error } = await supabase
        .from("profiles")
        .upsert(profileData);

      if (error) {
        console.error("Error creating profile:", error);
        throw error;
      }
      
      // Verify the data was saved correctly
      const { data: savedProfile, error: fetchError } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", userId)
        .single();
        
      if (fetchError) {
        console.error("Error fetching saved profile:", fetchError);
      } else {
        console.log("Saved profile data:", savedProfile);
        console.log("Saved first name:", savedProfile.first_name);
        console.log("Saved last name:", savedProfile.last_name);
        console.log("Saved phone number:", savedProfile.phone);
      }

      return { success: true, error: null };
    } catch (error) {
      console.error("Error creating profile:", error);
      return { success: false, error };
    }
  };

  const updateProfile = async (employee: Employee): Promise<ProfileResult> => {
    try {
      console.log("Updating profile for user:", employee.id);
      console.log("Profile data to update:", employee);
      console.log("First name being updated:", employee.first_name);
      console.log("Last name being updated:", employee.last_name);
      console.log("Phone being updated:", employee.phone);
      
      // Create the profile data object with explicit fields
      const profileData = {
        first_name: employee.first_name || '',
        last_name: employee.last_name || '',
        email: employee.email || '',
        phone: employee.phone || '', // Ensure phone is never null
        street: employee.street || '',
        city: employee.city || '',
        state: employee.state || '',
        zip_code: employee.zip_code || ''
      };
      
      console.log("Final profile data being updated:", profileData);
      
      const { error } = await supabase
        .from("profiles")
        .update(profileData)
        .eq("id", employee.id);

      if (error) {
        console.error("Error updating profile:", error);
        throw error;
      }
      
      // Verify the data was updated correctly
      const { data: updatedProfile, error: fetchError } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", employee.id)
        .single();
        
      if (fetchError) {
        console.error("Error fetching updated profile:", fetchError);
      } else {
        console.log("Updated profile data:", updatedProfile);
        console.log("Updated first name:", updatedProfile.first_name);
        console.log("Updated last name:", updatedProfile.last_name);
        console.log("Updated phone number:", updatedProfile.phone);
      }

      return { success: true, error: null };
    } catch (error) {
      console.error("Error updating profile:", error);
      return { success: false, error };
    }
  };

  return { createProfile, updateProfile };
};
